import api from "./api";

export const getBankAccount = (params) => {
  return api.get("v1/crm/bank-accounts", params);
};

export const getAccountSearch = (params) => {
  return api.get("/v1/crm/accounts/search?login=" + params);
};
